<template>
    <ul class="tags-dropdown-values">
        <li v-for="option in options" :key="option[idField]" :class="{'invalid': option.isInvalid}">
            <Tooltip
                v-if="tooltipField && option[tooltipField]"
                :text="String(option[tooltipField])"
                class="label font-6">
                <span class="truncate">
                    <slot name="preOption" :option="option"></slot>
                    {{option[displayField]}}
                </span>
            </Tooltip>
            <span v-else class="label font-6">
                <span class="truncate">
                    <slot name="preOption" :option="option"></slot>
                    {{option[displayField]}}
                </span>
            </span>
            <a href="#" class="remove-btn" @click.prevent.stop="$emit('remove', option)">
                <IconBase
                    iconName="closeIcon"
                    :iconColor="consts.COLORS.LIGHT_900"
                    display="flex"
                    width="8"
                    height="8"
                />
            </a>
        </li>
        <slot></slot>
    </ul>
</template>

<script>
import Tooltip from 'components/Tooltip/Tooltip.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';

export default {
    name: 'TagsDropdownValues',
    components: { IconBase, Tooltip },
    props: {
        idField: {
            type: String,
            default: 'id'
        },
        displayField: {
            type: String,
            default: 'displayText'
        },
        options: {
            type: Array,
            default: () => []
        },
        tooltipField: String
    },
    computed: {
        consts: () => consts
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.scss";

.tags-dropdown-values {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    margin: 0;
    padding: 5px 5px 0 5px;
    li {
        margin-right: 5px;
        max-width: 250px;
        margin-bottom: 7px;
        background-color: $light-300;
        color: $dark-300;
        border-radius: 100px;
        padding: 2px 10px 1px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: default;
        &.invalid .label {
            line-height: 14px;
            border-bottom: 1px dotted $negative-500;
        }
    }

    .label {
        display: flex;
        max-width: 214px;
    }
}

.remove-btn {
    padding: 4px 0;
    margin-left: 8px;
}
</style>
